// src/app/guards/auth.guard.ts

import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { AuthService } from '../services/auth.service';


@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private storageService: StorageService,
        private authService: AuthService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        const isAuthenticated = this.storageService.isTokenValid();

        if (isAuthenticated) {
            const currentUser = this.storageService.getCurrentUser(); 
            
            if (currentUser && currentUser.companies && currentUser.companies.length > 1) {
                if (state.url.includes('/auth/select-client')) {
                    return true;
                }
                if (!currentUser.selectedCompany || !this.storageService.getItem('selectedCompanyId')) {
                    // Si hay múltiples empresas y no ha seleccionado, mandamos a elegir empresa
                    // pero mantenemos el returnUrl para que al terminar elija vaya al link directo
                    return this.router.createUrlTree(['/auth/select-client'], { 
                        queryParams: { returnUrl: state.url } 
                    });
                }
            }

            //  Bloquear acceso a presupuestos y reportes
            if (this.authService.isRestrictedUser) {
                const urlLower = state.url.toLowerCase();
                if (urlLower.includes('/presupuestos') || urlLower.includes('/reportes')) {
                    // Lo enviamos de regreso a SU dashboard restringido
                    return this.router.createUrlTree(['/dashboards']);
                }
            }

            return true;
        } else {
            // REDIRECCIÓN A LOGIN CON returnUrl para redirigir después de login exitoso
            return this.router.createUrlTree(['/auth/login'], { 
                queryParams: { returnUrl: state.url } 
            }); 
        }
    }
}